// Mock data for BlueWater Construction Website

export const companyInfo = {
  name: "BlueWater",
  tagline: "Building Excellence, Delivering Quality",
  phone: "020 7834 3334",
  email: "info@bluewater-build.co.uk  ",
  address: "167-169 Great Portland Street, London, England, W1W 5PF",
  description: "BlueWater is a leading construction and building services company with over 25 years of experience delivering exceptional projects across the UK. We pride ourselves on quality craftsmanship, innovative solutions, and unwavering commitment to our clients.",
  aboutExtended: "Founded in 1998, BlueWater has grown from a small local contractor to one of the most trusted names in the UK construction industry. Our team of experienced professionals brings together expertise in commercial, residential, industrial, and infrastructure projects. We combine traditional craftsmanship with modern technology to deliver projects that exceed expectations, on time and within budget.",
  stats: [
    { value: "500+", label: "Projects Completed" },
    { value: "25+", label: "Years Experience" },
    { value: "150+", label: "Expert Team" },
    { value: "98%", label: "Client Satisfaction" }
  ]
};

export const sectors = [
  {
    id: 1,
    title: "Commercial Construction",
    description: "From office buildings to retail spaces, we deliver commercial projects that combine functionality with aesthetic appeal.",
    image: "https://images.pexels.com/photos/269077/pexels-photo-269077.jpeg",
    services: ["Office Buildings", "Retail Spaces", "Hotels", "Mixed-Use Developments"]
  },
  {
    id: 2,
    title: "Residential Development",
    description: "Creating quality homes and living spaces with attention to detail and modern design principles.",
    image: "https://images.unsplash.com/photo-1761877676992-0c232a7920f2",
    services: ["Luxury Homes", "Apartment Buildings", "Housing Estates", "Renovations"]
  },
  {
    id: 3,
    title: "Industrial Projects",
    description: "Specialized construction services for warehouses, manufacturing facilities, and industrial complexes.",
    image: "https://images.unsplash.com/photo-1724113595861-93b16bc264a5",
    services: ["Warehouses", "Manufacturing Plants", "Distribution Centers", "Storage Facilities"]
  },
  {
    id: 4,
    title: "Infrastructure & Civil Engineering",
    description: "Building the foundations of modern society with roads, bridges, and essential infrastructure projects.",
    image: "https://images.unsplash.com/photo-1769721209842-e46c60e7fbf9",
    services: ["Roads & Highways", "Bridges", "Utility Systems", "Site Development"]
  }
];

export const recentProjects = [
  {
    id: 1,
    title: "Canary Wharf Business Centre",
    category: "Commercial",
    location: "London",
    year: "2024",
    description: "A modern 15-story office building featuring sustainable design and state-of-the-art facilities.",
    image: "https://images.unsplash.com/photo-1715231667593-5a32b2828546",
    value: "£45M"
  },
  {
    id: 2,
    title: "Riverside Luxury Apartments",
    category: "Residential",
    location: "Manchester",
    year: "2024",
    description: "Premium residential development with 120 luxury apartments overlooking the waterfront.",
    image: "https://images.unsplash.com/photo-1739599211500-74e04a9ca175",
    value: "£28M"
  },
  {
    id: 3,
    title: "TechHub Distribution Center",
    category: "Industrial",
    location: "Birmingham",
    year: "2023",
    description: "State-of-the-art logistics facility with automated systems and eco-friendly features.",
    image: "https://images.pexels.com/photos/36006588/pexels-photo-36006588.jpeg",
    value: "£18M"
  },
  {
    id: 4,
    title: "Greenwich Heritage Restoration",
    category: "Commercial",
    location: "Greenwich",
    year: "2023",
    description: "Careful restoration and modernization of a historic Victorian-era building.",
    image: "https://images.unsplash.com/photo-1649586777582-cdc0684201a8",
    value: "£12M"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "James Mitchell",
    company: "Sterling Properties",
    role: "Managing Director",
    content: "BlueWater's professionalism and attention to detail are second to none. They delivered our project on time and exceeded our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Williams",
    company: "Modern Living Developments",
    role: "Project Manager",
    content: "Working with BlueWater has been a fantastic experience. Their expertise and commitment to quality are evident in every aspect.",
    rating: 5
  },
  {
    id: 3,
    name: "David Thompson",
    company: "TechHub Logistics",
    role: "CEO",
    content: "The team at BlueWater transformed our vision into reality. Outstanding craftsmanship and project management.",
    rating: 5
  }
];

export const certifications = [
  "ISO 9001:2015 Quality Management",
  "ISO 14001:2015 Environmental Management",
  "ISO 45001:2018 Health & Safety",
  "Constructionline Gold Member",
  "CHAS Accredited"
];
